import '@bayesprep/shared-ui/errors/errors.css';
import { ImageAccessProvider } from '@bayesprep/shared-ui/images';
import { resolveImageBytes } from './utils/imageUtils';
import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import App from './App.jsx'
import './index.css'
// KaTeX CSS is imported by @bayesprep/shared-ui/katex - no need to import here

const getImageIdentity = () => {
  const token = localStorage.getItem('authToken');
  return token ? token + '|' + (localStorage.getItem('tenantCode') || '') : '';
};

const router = createBrowserRouter([{path: '*', element: <ImageAccessProvider resolveImage={resolveImageBytes} getIdentity={getImageIdentity}><App /></ImageAccessProvider>}]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
)
